"use client"

import * as React from "react"
import { SearchX } from "lucide-react"

interface EmptyStateProps {
  /** The query the user typed (rendered in quotes in the title). */
  query: string
  /** Called when the user clicks "Reset filters" — typically clears
   *  search + tier filter at the parent level. */
  onReset: () => void
}

/**
 * Empty state shown when search + tier filters narrow the list to zero
 * brands (handoff §8). Centered card with dashed border, 56×56 gray
 * icon tile, headline + body, orange CTA pill.
 */
export function EmptyState({ query, onReset }: EmptyStateProps) {
  return (
    <div className="rounded-[14px] border border-dashed border-gray-200 px-5 py-[60px] text-center">
      <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-gray-100">
        <SearchX className="h-6 w-6 text-gray-400" aria-hidden />
      </div>
      <h2 className="text-[18px] font-extrabold text-gray-900">
        {query ? <>No brands match &ldquo;{query}&rdquo;</> : "No brands match your filters"}
      </h2>
      <p className="mt-2 text-sm text-gray-500">
        Try clearing filters or searching for something else.
      </p>
      <button
        type="button"
        onClick={onReset}
        className="mt-6 inline-flex items-center justify-center rounded-full bg-[#ff9951] px-5 py-2.5 text-[13px] font-bold text-[var(--color-brand-action-text)] transition-colors hover:bg-[#ff8533] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff9951] focus-visible:ring-offset-2"
      >
        Reset filters
      </button>
    </div>
  )
}
